(function () {
  var STORAGE_KEY = "laboo:gallery-planner:v1";
  var ROTATE_PROMPT_KEY = "laboo:gallery-planner:rotate-prompt:v1";
  var CUSTOM_ROOM_KEY = "laboo:gallery-planner:custom-room:v1";
  var CUSTOM_ROOM_MAX_EDGE = 1800;
  var MAX_ARTWORKS = 20;
  var US_POPULAR_SIZES = ["8 x 12 in", "12 x 16 in", "16 x 24 in", "24 x 36 in", "30 x 40 in"];
  var US_SIZE_ORDER = [
    "5 x 7 in", "8 x 12 in", "10 x 10 in", "11 x 14 in", "12 x 12 in",
    "12 x 16 in", "14 x 14 in", "16 x 16 in", "16 x 20 in", "16 x 24 in",
    "18 x 18 in", "20 x 20 in", "20 x 28 in", "24 x 32 in", "24 x 36 in",
    "28 x 28 in", "28 x 40 in", "30 x 40 in"
  ];

  function init(root) {
    if (root.dataset.lpReady === "true") return;
    root.dataset.lpReady = "true";

    document.documentElement.classList.add("laboo-planner-page");
    document.body.classList.add("laboo-planner-page");

    var phoneLandscapeQuery = window.matchMedia("(orientation: landscape) and (max-width: 1024px) and (max-height: 600px)");
    var mobilePortraitQuery = window.matchMedia("(max-width: 820px) and (orientation: portrait)");
    var mobilePlannerQuery = window.matchMedia("(max-width: 820px), (orientation: landscape) and (max-width: 1024px) and (max-height: 600px)");
    function syncPlannerViewport() {
      var isMobilePlanner = mobilePlannerQuery.matches;
      document.documentElement.classList.toggle("laboo-planner-mode", isMobilePlanner);
      document.body.classList.toggle("laboo-planner-mode", isMobilePlanner);
      root.classList.toggle("is-phone-landscape", phoneLandscapeQuery.matches);
    }
    syncPlannerViewport();
    if (mobilePlannerQuery.addEventListener) mobilePlannerQuery.addEventListener("change", syncPlannerViewport);
    else mobilePlannerQuery.addListener(syncPlannerViewport);
    window.addEventListener("pagehide", function () {
      document.documentElement.classList.remove("laboo-planner-mode");
      document.body.classList.remove("laboo-planner-mode");
      document.documentElement.classList.remove("laboo-planner-page");
      document.body.classList.remove("laboo-planner-page");
    }, { once: true });

    var configElement = root.querySelector("[data-lp-config]");
    var config = {};
    try { config = JSON.parse(configElement ? configElement.textContent : "{}"); } catch (error) { config = {}; }

    var labels = config.labels || {};
    var feedUrl = root.dataset.feedUrl || "/collections/art-prints-and-posters?view=planner-data";
    var rootUrl = root.dataset.rootUrl || (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    if (rootUrl.charAt(rootUrl.length - 1) !== "/") rootUrl += "/";
    var initialProductHandle = "";
    try { initialProductHandle = new URLSearchParams(window.location.search).get("product") || ""; } catch (error) { initialProductHandle = ""; }
    var initialSetHandles = [];
    try {
      initialSetHandles = (new URLSearchParams(window.location.search).get("prints") || "").split(",").map(function (handle) {
        return handle.trim();
      }).filter(function (handle) { return /^[a-z0-9-]+$/.test(handle); });
    } catch (error) { initialSetHandles = []; }

    var elements = {
      catalogue: root.querySelector(".lp-catalogue"),
      catalogueIntro: root.querySelector(".lp-catalogue__intro"),
      products: root.querySelector("[data-lp-products]"),
      status: root.querySelector("[data-lp-status]"),
      loadMore: root.querySelector("[data-lp-load-more]"),
      search: root.querySelector("[data-lp-search]"),
      categoryTrigger: root.querySelector("[data-lp-category-trigger]"),
      categoryLabel: root.querySelector("[data-lp-category-label]"),
      categoryPanel: root.querySelector("[data-lp-category-panel]"),
      categoryClose: Array.prototype.slice.call(root.querySelectorAll("[data-lp-category-close]")),
      categoryOptions: Array.prototype.slice.call(root.querySelectorAll("[data-lp-category-option]")),
      categoryGroups: Array.prototype.slice.call(root.querySelectorAll(".lp-category-group")),
      filterDetails: root.querySelector(".lp-filters"),
      filterSummary: root.querySelector(".lp-filters > summary"),
      filters: Array.prototype.slice.call(root.querySelectorAll("[data-lp-filter]")),
      roomButtons: Array.prototype.slice.call(root.querySelectorAll("[data-lp-room]")),
      roomStage: root.querySelector("[data-lp-room-stage]"),
      roomContent: root.querySelector("[data-lp-room-content]"),
      roomImage: root.querySelector("[data-lp-room-image]"),
      roomFile: root.querySelector("[data-lp-room-file]"),
      roomHint: root.querySelector("[data-lp-room-hint]"),
      roomChange: root.querySelector("[data-lp-room-change]"),
      wall: root.querySelector("[data-lp-wall-surface]"),
      empty: root.querySelector("[data-lp-empty]"),
      zoom: root.querySelector("[data-lp-zoom]"),
      zoomOutput: root.querySelector("[data-lp-zoom-output]"),
      itemCount: root.querySelector("[data-lp-item-count]"),
      total: root.querySelector("[data-lp-total]"),
      addWall: root.querySelector("[data-lp-add-wall]"),
      inspector: root.querySelector("[data-lp-inspector]"),
      selectedTitle: root.querySelector("[data-lp-selected-title]"),
      size: root.querySelector("[data-lp-size]"),
      frameInputs: Array.prototype.slice.call(root.querySelectorAll("[data-lp-frame]")),
      remove: root.querySelector("[data-lp-remove]"),
      deselect: root.querySelector("[data-lp-deselect]"),
      scrollCatalogue: root.querySelector("[data-lp-scroll-catalogue]"),
      catalogueClose: root.querySelector("[data-lp-close-catalogue]"),
      catalogueBackdrop: root.querySelector("[data-lp-catalogue-backdrop]"),
      rotatePrompt: root.querySelector("[data-lp-rotate-prompt]"),
      rotateDismiss: root.querySelector("[data-lp-rotate-dismiss]"),
      saveStatus: root.querySelector("[data-lp-save-status]"),
      wishlistCount: root.querySelector("[data-lp-wishlist-count]"),
      sizeGuideLink: root.querySelector("[data-lp-size-guide-link]")
    };

    var state = {
      products: [],
      productMap: new Map(),
      catalogueHandles: new Set(),
      productRequests: new Map(),
      metaRequests: new Map(),
      searchResults: null,
      searchLoading: false,
      page: 0,
      pages: 1,
      totalProducts: 0,
      loading: false,
      tab: "all",
      search: "",
      categoryUrl: "",
      categoryHandle: "",
      filters: { rooms: "", styles: "", subjects: "" },
      filterNames: { rooms: "", styles: "", subjects: "" },
      filterParams: { rooms: "", styles: "", subjects: "" },
      filterOptions: { rooms: new Map(), styles: new Map(), subjects: new Map() },
      items: [],
      selectedId: "",
      room: "sofa",
      artworkZoom: 1
    };
    var searchTimer = 0;
    var searchRequestId = 0;
    var catalogueRequestId = 0;
    var saveMessageTimer = 0;
    var roomHintTimer = 0;
    var categoryCatalogueScroll = 0;

    restoreCustomRoom();
    restoreDraft();
    bindEvents();
    preserveFilterDisclosurePosition();
    syncOrientationExperience();
    window.setTimeout(maybeShowRotatePrompt, 450);
    setRoom(state.room, false);
    setArtworkZoom(state.artworkZoom, false, false);
    renderCanvas();
    renderSummary();
    renderWishlistCount();
    loadPage(1, true)
      .then(function () { return refreshRestoredItems(); })
      .then(addInitialProduct);

    function escapeHTML(value) {
      var span = document.createElement("span");
      span.textContent = String(value == null ? "" : value);
      return span.innerHTML;
    }

    function hideRotatePrompt() {
      if (!elements.rotatePrompt || elements.rotatePrompt.hidden) return;
      elements.rotatePrompt.classList.remove("is-visible");
      window.setTimeout(function () { elements.rotatePrompt.hidden = true; }, 180);
    }

    function maybeShowRotatePrompt() {
      if (!elements.rotatePrompt || !mobilePortraitQuery.matches) return;
      var alreadyShown = false;
      try { alreadyShown = window.sessionStorage.getItem(ROTATE_PROMPT_KEY) === "shown"; } catch (error) { alreadyShown = false; }
      if (alreadyShown || elements.rotatePrompt.dataset.lpPromptShown === "true") return;
      elements.rotatePrompt.dataset.lpPromptShown = "true";
      try { window.sessionStorage.setItem(ROTATE_PROMPT_KEY, "shown"); } catch (error) {}
      elements.rotatePrompt.hidden = false;
      window.requestAnimationFrame(function () { elements.rotatePrompt.classList.add("is-visible"); });
    }

    function openCatalogue() {
      if (!phoneLandscapeQuery.matches) {
        elements.catalogueIntro.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      root.classList.add("is-catalogue-open");
      elements.catalogue.inert = false;
      elements.scrollCatalogue.setAttribute("aria-expanded", "true");
      window.setTimeout(function () {
        try { elements.catalogueClose.focus({ preventScroll: true }); } catch (error) { elements.catalogueClose.focus(); }
      }, 180);
    }

    function closeCatalogue(returnFocus) {
      if (elements.categoryPanel && !elements.categoryPanel.hidden) setCategoryPanelOpen(false, false);
      root.classList.remove("is-catalogue-open");
      elements.scrollCatalogue.setAttribute("aria-expanded", "false");
      if (phoneLandscapeQuery.matches) elements.catalogue.inert = true;
      else elements.catalogue.inert = false;
      if (returnFocus) {
        try { elements.scrollCatalogue.focus({ preventScroll: true }); } catch (error) { elements.scrollCatalogue.focus(); }
      }
    }

    function syncOrientationExperience() {
      syncPlannerViewport();
      if (phoneLandscapeQuery.matches) {
        hideRotatePrompt();
        if (!root.classList.contains("is-catalogue-open")) elements.catalogue.inert = true;
        return;
      }
      closeCatalogue(false);
      if (mobilePortraitQuery.matches) window.setTimeout(maybeShowRotatePrompt, 250);
    }

    function bindMediaChange(query, handler) {
      if (query.addEventListener) query.addEventListener("change", handler);
      else query.addListener(handler);
    }

    bindMediaChange(phoneLandscapeQuery, syncOrientationExperience);
    bindMediaChange(mobilePortraitQuery, syncOrientationExperience);

    function preserveFilterDisclosurePosition() {
      if (!elements.filterDetails || !elements.filterSummary) return;
      elements.filterSummary.addEventListener("click", function (event) {
        event.preventDefault();
        var scrollLeft = window.scrollX;
        var scrollTop = window.scrollY;
        var restorePosition = function () { window.scrollTo(scrollLeft, scrollTop); };
        elements.filterDetails.open = !elements.filterDetails.open;
        restorePosition();
        window.requestAnimationFrame(function () {
          restorePosition();
          window.requestAnimationFrame(restorePosition);
        });
      });
    }

    function formatMoney(cents) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || config.currency || "GBP";
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency: currency,
          maximumFractionDigits: Number(cents || 0) % 100 === 0 ? 0 : 2
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return (Number(cents || 0) / 100).toFixed(2) + " " + currency;
      }
    }

    function heartSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" fill="currentColor" fill-opacity="0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    function wishlistHandles() {
      return window.LabooWishlist && typeof window.LabooWishlist.getHandles === "function"
        ? window.LabooWishlist.getHandles()
        : [];
    }

    function renderWishlistCount() {
      if (elements.wishlistCount) elements.wishlistCount.textContent = "(" + wishlistHandles().length + ")";
    }

    function setCategoryPanelOpen(open, returnFocus) {
      if (!elements.categoryPanel || !elements.categoryTrigger) return;
      if (open) {
        categoryCatalogueScroll = elements.catalogue.scrollTop;
        elements.catalogue.scrollTop = 0;
        elements.catalogue.classList.add("is-category-open");
        elements.categoryPanel.hidden = false;
        elements.categoryTrigger.setAttribute("aria-expanded", "true");
        window.setTimeout(function () {
          var target = elements.categoryPanel.querySelector("[data-lp-category-close]");
          if (target) {
            try { target.focus({ preventScroll: true }); } catch (error) { target.focus(); }
          }
        }, 30);
        return;
      }

      elements.catalogue.classList.remove("is-category-open");
      elements.categoryPanel.hidden = true;
      elements.categoryTrigger.setAttribute("aria-expanded", "false");
      elements.catalogue.scrollTop = categoryCatalogueScroll;
      if (returnFocus) {
        try { elements.categoryTrigger.focus({ preventScroll: true }); } catch (error) { elements.categoryTrigger.focus(); }
      }
    }

    function applyCategory(button) {
      state.categoryUrl = button.dataset.categoryUrl || "";
      state.categoryHandle = button.dataset.categoryHandle || "";
      elements.categoryLabel.textContent = button.dataset.categoryLabel || labels.allCategories || "All categories";
      elements.categoryOptions.forEach(function (option) {
        var isSelected = (option.dataset.categoryHandle || "") === state.categoryHandle;
        option.classList.toggle("is-active", isSelected);
        if (isSelected) option.setAttribute("aria-current", "true");
        else option.removeAttribute("aria-current");
      });

      state.search = "";
      state.searchResults = null;
      state.searchLoading = false;
      searchRequestId += 1;
      elements.search.value = "";

      Object.keys(state.filters).forEach(function (key) {
        state.filters[key] = "";
        state.filterNames[key] = "";
        state.filterParams[key] = "";
        state.filterOptions[key].clear();
      });
      elements.filters.forEach(function (select) { select.selectedIndex = 0; });

      state.products = [];
      state.catalogueHandles.clear();
      state.page = 0;
      state.pages = 1;
      state.totalProducts = 0;
      elements.products.innerHTML = "";
      setCategoryPanelOpen(false, true);
      loadPage(1, true);
    }

    function buildFeedUrl(page) {
      var url = new URL(state.categoryUrl || feedUrl, window.location.origin);
      url.searchParams.set("view", "planner-data");
      url.searchParams.set("page", page);
      Object.keys(state.filters).forEach(function (key) {
        if (!state.filters[key]) return;
        var param = state.filterParams[key];
        if (param) url.searchParams.append(param, state.filters[key]);
      });
      return url.toString();
    }

    function mergeFilterOptions(filterOptions) {
      Object.keys(state.filterOptions).forEach(function (key) {
        ((filterOptions && filterOptions[key]) || []).forEach(function (item) {
          if (!item || !item.value || !item.label || !item.param) return;
          state.filterOptions[key].set(item.value, item);
        });
      });
    }

    function mergeProductFilterOptions(products) {
      Object.keys(state.filterOptions).forEach(function (key) {
        var knownNames = new Set(Array.from(state.filterOptions[key].values()).map(function (item) {
          return normalizedFilterName(item.label);
        }));
        (products || []).forEach(function (product) {
          ((product.filters && product.filters[key]) || []).forEach(function (item) {
            var label = item && (item.name || item.handle);
            var normalizedName = normalizedFilterName(label);
            if (!label || !normalizedName || knownNames.has(normalizedName)) return;
            var value = "client:" + key + ":" + (item.handle || normalizedName);
            state.filterOptions[key].set(value, {
              label: label,
              value: value,
              param: ""
            });
            knownNames.add(normalizedName);
          });
        });
      });
    }

    async function loadPage(page, replace) {
      if (state.loading && !replace) return;
      if (!replace && page > state.pages && state.page > 0) return;
      var requestId = replace ? ++catalogueRequestId : catalogueRequestId;
      state.loading = true;
      elements.status.textContent = labels.loading || "Loading artwork...";
      if (elements.loadMore) elements.loadMore.disabled = true;

      try {
        var response = await fetch(buildFeedUrl(page), {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        if (!response.ok) throw new Error("Catalogue request failed");
        var payload = await response.json();
        if (requestId !== catalogueRequestId) return;
        if (replace) {
          state.products = [];
          state.catalogueHandles.clear();
        }
        state.page = Number(payload.page || page);
        state.pages = Math.max(1, Number(payload.pages || 1));
        state.totalProducts = Number(payload.count || 0);
        mergeFilterOptions(payload.filterOptions);

        (payload.products || []).forEach(function (product) {
          if (!product || !product.handle) return;
          if (state.categoryHandle) product._catalogueCategory = state.categoryHandle;
          state.productMap.set(product.handle, product);
          if (state.catalogueHandles.has(product.handle)) return;
          state.catalogueHandles.add(product.handle);
          state.products.push(product);
        });

        mergeProductFilterOptions(payload.products || []);
        refreshFilterOptions();
        renderProducts();
        return true;
      } catch (error) {
        if (requestId !== catalogueRequestId) return;
        elements.status.textContent = labels.error || "Something went wrong. Please try again.";
        return false;
      } finally {
        if (requestId !== catalogueRequestId) return;
        state.loading = false;
        if (elements.loadMore) elements.loadMore.disabled = false;
      }
    }

    function productMetaUrl(handle) {
      return rootUrl + "products/" + encodeURIComponent(handle) + "?view=planner-data";
    }

    function fetchProductMeta(handle) {
      var existing = state.productMap.get(handle);
      if (existing && existing.artworkImage) return Promise.resolve(existing);
      if (state.metaRequests.has(handle)) return state.metaRequests.get(handle);

      var request = fetch(productMetaUrl(handle), {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      }).then(function (response) {
        if (!response.ok) throw new Error("Product data request failed");
        return response.json();
      }).then(function (product) {
        if (product && product.handle) state.productMap.set(product.handle, product);
        return product;
      }).catch(function () {
        return existing || null;
      });

      state.metaRequests.set(handle, request);
      return request;
    }

    // 24 Oct 2026 (Claude): ?prints=a,b,c (from a gallery set page) opens the set as a new, neatly arranged wall.
    async function addInitialSet() {
      var handles = initialSetHandles.slice(0, MAX_ARTWORKS);
      state.items = [];
      state.selectedId = "";
      for (var i = 0; i < handles.length; i++) {
        var productMeta = await fetchProductMeta(handles[i]);
        if (productMeta && productMeta.handle) {
          state.productMap.set(productMeta.handle, productMeta);
          await addProduct(productMeta.handle);
        }
      }
      arrangeItems(state.items);
      state.selectedId = "";
      renderCanvas();
      renderSummary();
      saveDraft(false);
      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("prints");
        cleanUrl.searchParams.delete("set");
        window.history.replaceState(null, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      } catch (error) {
        // Leaving the address as it is only means a reload opens the set again.
      }
    }

    // Rows centred over the room's furniture with a 6cm gap: 1 row up to 3 prints, 2 rows up to 8, then 3.
    function arrangeItems(items) {
      if (!items.length) return;
      var stage = elements.roomContent.getBoundingClientRect();
      var aspect = stage.width && stage.height ? stage.width / stage.height : 1.5;
      var room = activeRoom();
      var gapX = 6 / Number(room.wallWidthCm || 380) * 100 * state.artworkZoom;
      var gapY = gapX * aspect;
      var rowCount = items.length <= 3 ? 1 : (items.length <= 8 ? 2 : 3);
      var perRow = Math.ceil(items.length / rowCount);
      var rows = [];
      for (var start = 0; start < items.length; start += perRow) rows.push(items.slice(start, start + perRow));
      var sized = rows.map(function (row) {
        return row.map(function (item) {
          var width = artworkWidthPercent(item);
          var ratio = Number(item.widthCm || 1) / Math.max(1, Number(item.heightCm || 1));
          return { item: item, width: width, height: width * aspect / ratio };
        });
      });
      var rowHeights = sized.map(function (row) { return Math.max.apply(null, row.map(function (entry) { return entry.height; })); });
      var totalHeight = rowHeights.reduce(function (sum, height) { return sum + height; }, 0) + gapY * (rows.length - 1);
      var top = Math.max(3, Number(room.defaultY || 34) - totalHeight / 2);
      sized.forEach(function (row, rowIndex) {
        var rowWidth = row.reduce(function (sum, entry) { return sum + entry.width; }, 0) + gapX * (row.length - 1);
        var left = 50 - rowWidth / 2;
        var centreY = top + rowHeights[rowIndex] / 2;
        row.forEach(function (entry) {
          entry.item.x = left + entry.width / 2;
          entry.item.y = centreY;
          left += entry.width + gapX;
        });
        top += rowHeights[rowIndex] + gapY;
      });
    }

    async function addInitialProduct() {
      if (initialSetHandles.length) return addInitialSet();
      if (!initialProductHandle) return;
      var existingItem = state.items.find(function (item) { return item.handle === initialProductHandle; });
      if (existingItem) {
        state.selectedId = existingItem.uid;
        renderCanvas();
        renderSummary();
        return;
      }

      var productMeta = await fetchProductMeta(initialProductHandle);
      if (!productMeta || !productMeta.handle) return;
      state.productMap.set(productMeta.handle, productMeta);
      await addProduct(productMeta.handle);
    }

    async function performSearch() {
      var query = state.search;
      var requestId = ++searchRequestId;

      if (query.length < 2) {
        state.searchResults = query
          ? state.products.filter(function (product) { return normalizedSearchText(product).indexOf(query) !== -1; })
          : null;
        state.searchLoading = false;
        renderProducts();
        return;
      }

      state.searchLoading = true;
      elements.status.textContent = labels.loading || "Searching artwork...";
      renderProducts();

      try {
        var searchUrl = rootUrl + "search/suggest.json?q=" + encodeURIComponent(query) +
          "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide";
        var response = await fetch(searchUrl, {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        if (!response.ok) throw new Error("Search request failed");
        var payload = await response.json();
        var suggestions = payload && payload.resources && payload.resources.results
          ? payload.resources.results.products || []
          : [];
        var products = await Promise.all(suggestions.map(function (suggestion) {
          return fetchProductMeta(suggestion.handle);
        }));
        if (requestId !== searchRequestId) return;
        state.searchResults = products.filter(Boolean);
        mergeProductFilterOptions(state.searchResults);
        refreshFilterOptions();
      } catch (error) {
        if (requestId !== searchRequestId) return;
        state.searchResults = [];
        elements.status.textContent = labels.error || "Search is unavailable. Please try again.";
      } finally {
        if (requestId === searchRequestId) {
          state.searchLoading = false;
          renderProducts();
        }
      }
    }

    async function loadWishlistProducts() {
      var handles = wishlistHandles();
      if (!handles.length) {
        renderProducts();
        return;
      }
      elements.status.textContent = labels.loading || "Loading saved artwork...";
      await Promise.all(handles.map(fetchProductMeta));
      renderProducts();
    }

    function normalizedSearchText(product) {
      var filters = product.filters || {};
      var filterNames = ["rooms", "styles", "subjects", "artists"].reduce(function (all, key) {
        return all.concat((filters[key] || []).map(function (item) { return item.name || item.handle || ""; }));
      }, []);
      return [product.title, product.type].concat(product.tags || [], filterNames).join(" ").toLowerCase();
    }

    function normalizedFilterName(value) {
      return String(value || "").trim().toLowerCase();
    }

    function matchesFilters(product) {
      if (!product.available) return false;
      if (state.categoryHandle) {
        var belongsToCategory = product._catalogueCategory === state.categoryHandle ||
          (product.collectionHandles || []).indexOf(state.categoryHandle) !== -1;
        if (!belongsToCategory) return false;
      }
      return Object.keys(state.filters).every(function (key) {
        var selected = state.filters[key];
        if (!selected) return true;
        var selectedName = state.filterNames[key];
        return ((product.filters && product.filters[key]) || []).some(function (item) {
          return normalizedFilterName(item.name) === selectedName;
        });
      });
    }

    function visibleProductCount() {
      return state.products.filter(matchesFilters).length;
    }

    function hasClientOnlyFilter() {
      return Object.keys(state.filters).some(function (key) {
        return state.filters[key] && !state.filterParams[key];
      });
    }

    async function loadMoreProducts() {
      if (state.loading) return;
      var visibleBefore = visibleProductCount();

      do {
        var loaded = await loadPage(state.page + 1, false);
        if (!loaded) break;
      } while (hasClientOnlyFilter() && state.page < state.pages && visibleProductCount() === visibleBefore);
    }

    function renderProducts() {
      var saved = wishlistHandles();
      var source = state.searchResults !== null
        ? state.searchResults
        : state.tab === "wishlist"
          ? saved.map(function (handle) { return state.productMap.get(handle); }).filter(Boolean)
          : state.products;
      if (state.tab === "wishlist") {
        source = source.filter(function (product) { return saved.indexOf(product.handle) !== -1; });
      }
      var visible = source.filter(matchesFilters);

      elements.products.innerHTML = visible.map(function (product) {
        var isSaved = saved.indexOf(product.handle) !== -1;
        var price = Number(product.price || 0);
        var compare = Number(product.compareAtPrice || 0);
        return '<article class="lp-product-card" data-lp-product="' + escapeHTML(product.handle) + '">' +
          '<button type="button" class="lp-product-card__wishlist' + (isSaved ? " is-saved" : "") + '" data-lp-wishlist="' + escapeHTML(product.handle) + '" aria-pressed="' + String(isSaved) + '" aria-label="' + escapeHTML((isSaved ? labels.removeWishlist : labels.addWishlist) || "Wishlist") + '">' + heartSvg() + '</button>' +
          '<button type="button" class="lp-product-card__image" data-lp-add-product="' + escapeHTML(product.handle) + '" aria-label="' + escapeHTML((labels.addArtwork || "Add artwork") + ": " + product.title) + '">' +
            '<img src="' + escapeHTML(product.featuredImage || product.artworkImage) + '" alt="' + escapeHTML(product.title) + '" loading="lazy" width="420" height="520">' +
            '<span class="lp-product-card__add" aria-hidden="true">+</span>' +
          '</button>' +
          '<div class="lp-product-card__body">' +
            '<a class="lp-product-card__title" href="' + escapeHTML(product.url) + '">' + escapeHTML(product.title) + '</a>' +
            '<div class="lp-product-card__price"><span>' + escapeHTML(formatMoney(price)) + '</span>' + (compare > price ? '<del>' + escapeHTML(formatMoney(compare)) + '</del>' : '') + '</div>' +
          '</div>' +
        '</article>';
      }).join("");

      if (state.searchLoading) {
        elements.status.textContent = labels.loading || "Searching artwork...";
      } else if (!visible.length && !state.loading) {
        elements.status.textContent = labels.noResults || "No matching artwork found.";
      } else {
        elements.status.textContent = state.searchResults !== null || state.tab === "wishlist" || hasClientOnlyFilter()
          ? visible.length + " " + (visible.length === 1 ? (labels.item || "item") : (labels.items || "items"))
          : state.products.length + (state.totalProducts ? " / " + state.totalProducts : "");
      }

      if (elements.loadMore) {
        elements.loadMore.hidden = state.searchResults !== null || state.tab === "wishlist" || state.page >= state.pages;
        elements.loadMore.textContent = labels.loadMore || "Load more";
      }
    }

    function refreshFilterOptions() {
      elements.filters.forEach(function (select) {
        var key = select.dataset.lpFilter;
        var current = state.filters[key] || "";
        var options = Array.from(state.filterOptions[key].values());
        var first = select.options[0] ? select.options[0].outerHTML : '<option value="">All</option>';
        select.innerHTML = first + options.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        }).map(function (item) {
          return '<option value="' + escapeHTML(item.value) + '" data-filter-param="' + escapeHTML(item.param) + '" data-filter-name="' + escapeHTML(normalizedFilterName(item.label)) + '">' + escapeHTML(item.label) + '</option>';
        }).join("");
        select.value = current;
      });
    }

    function productJsonUrl(handle) {
      return rootUrl + "products/" + encodeURIComponent(handle) + ".js";
    }

    function fetchProduct(handle) {
      if (state.productRequests.has(handle)) return state.productRequests.get(handle);
      var request = fetch(productJsonUrl(handle), {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      }).then(function (response) {
        if (!response.ok) throw new Error("Product request failed");
        return response.json();
      });
      state.productRequests.set(handle, request);
      return request;
    }

    function originalVariantTitle(variant) {
      return String((variant && (variant.option1 || variant.title)) || "").replace(/^Size:\s*/i, "").trim();
    }

    function displayVariantTitle(value) {
      var formatter = window.LabooMarketSizeLabels && window.LabooMarketSizeLabels.format;
      return typeof formatter === "function" ? formatter(value) : value;
    }

    function parseDimensions(value, product) {
      var match = String(value || "").match(/(?:A\d\s*-\s*)?(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i);
      var width = match ? Number(match[1]) : 40;
      var height = match ? Number(match[2]) : 50;
      var artworkRatio = Number(product.artworkWidth || 0) / Math.max(1, Number(product.artworkHeight || 0));
      if (artworkRatio > 1.04 && width < height) {
        var landscapeHeight = width;
        width = height;
        height = landscapeHeight;
      } else if (artworkRatio > 0 && artworkRatio < .96 && width > height) {
        var portraitHeight = width;
        width = height;
        height = portraitHeight;
      }
      return { width: width, height: height };
    }

    function availableVariants(productJson, productMeta) {
      var seen = new Set();
      var options = (productJson.variants || []).filter(function (variant) {
        return variant.available;
      }).map(function (variant) {
        var original = originalVariantTitle(variant);
        var label = displayVariantTitle(original);
        if (label == null) return null;
        // UK and EU shoppers see cm only in the planner, not the "= 5 x 7"" inch suffix.
        if (!isUSMarket()) label = String(label).replace(/\s*=\s*[\d.]+\s*x\s*[\d.]+\s*("|in)?\s*$/i, "");
        if (seen.has(label)) return null;
        seen.add(label);
        var dimensions = parseDimensions(original, productMeta);
        return {
          id: Number(variant.id),
          label: label || original,
          original: original,
          widthCm: dimensions.width,
          heightCm: dimensions.height,
          price: Number(variant.price || 0),
          compareAtPrice: Number(variant.compare_at_price || 0)
        };
      }).filter(Boolean);

      if (window.LabooMarketSizeLabels && window.LabooMarketSizeLabels.isUSMarket && window.LabooMarketSizeLabels.isUSMarket()) {
        options.sort(function (a, b) {
          var aIndex = US_SIZE_ORDER.indexOf(a.label);
          var bIndex = US_SIZE_ORDER.indexOf(b.label);
          return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex);
        });
      }
      return options;
    }

    function isUSMarket() {
      return Boolean(window.LabooMarketSizeLabels && window.LabooMarketSizeLabels.isUSMarket && window.LabooMarketSizeLabels.isUSMarket());
    }

    // 24 Oct 2026 (Claude): a short "Popular sizes" group (A sizes, or the main US inch sizes); the rest go under "More sizes".
    function isPopularOption(option) {
      if (isUSMarket()) return US_POPULAR_SIZES.indexOf(option.label) >= 0;
      return /^A[0-4]\b/.test(option.label);
    }

    function groupedOptions(options) {
      var popular = options.filter(isPopularOption);
      if (popular.length < 3) return { popular: options, more: [] };
      return { popular: popular, more: options.filter(function (option) { return !isPopularOption(option); }) };
    }

    // New prints start near 30cm on the short side (A3, 30 x 40cm, 30 x 30cm or 12 x 16 in) so the wall reads at a glance.
    function defaultOption(options) {
      var pool = groupedOptions(options).popular;
      return pool.slice().sort(function (a, b) {
        var aGap = Math.abs(Math.min(a.widthCm, a.heightCm) - 30);
        var bGap = Math.abs(Math.min(b.widthCm, b.heightCm) - 30);
        return aGap - bGap || a.price - b.price;
      })[0] || options[0];
    }

    function multibuyPercent(quantity) {
      return (config.multibuy || []).reduce(function (best, tier) {
        return quantity >= Number(tier.min) ? Math.max(best, Number(tier.percent)) : best;
      }, 0);
    }

    async function addProduct(handle) {
      if (state.items.length >= MAX_ARTWORKS) return;
      var productMeta = state.productMap.get(handle);
      if (!productMeta) return;
      elements.status.textContent = labels.loading || "Loading artwork...";

      try {
        var productJson = await fetchProduct(handle);
        var options = availableVariants(productJson, productMeta);
        if (!options.length) throw new Error("No available sizes");
        var selected = defaultOption(options);
        var room = config.rooms[state.room] || config.rooms.sofa;
        var offset = state.items.length % 5;
        var item = {
          uid: String(Date.now()) + "-" + Math.random().toString(36).slice(2, 8),
          handle: handle,
          title: productMeta.title,
          url: productMeta.url,
          artworkImage: productMeta.artworkImage || productMeta.featuredImage,
          artworkWidth: productMeta.artworkWidth,
          artworkHeight: productMeta.artworkHeight,
          x: 30 + offset * 10,
          y: Number(room.defaultY || 32) + (offset % 2) * 5,
          frame: "none",
          variantId: selected.id,
          sizeLabel: selected.label,
          widthCm: selected.widthCm,
          heightCm: selected.heightCm,
          price: selected.price,
          compareAtPrice: selected.compareAtPrice,
          options: options
        };
        state.items.push(item);
        state.selectedId = item.uid;
        renderCanvas();
        renderSummary();
        renderInspector();
        saveDraft(true);
        elements.status.textContent = "";
        // On phones the catalogue sits below the room, so bring the room back into view to show the new print.
        if (mobilePortraitQuery.matches && elements.roomStage) {
          elements.roomStage.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } catch (error) {
        elements.status.textContent = labels.error || "This artwork could not be added.";
      }
    }

    function activeRoom() {
      return config.rooms[state.room] || config.rooms.sofa || { wallWidthCm: 380, defaultY: 34 };
    }

    function artworkWidthPercent(item) {
      var baseWidth = Number(item.widthCm || 40) / Number(activeRoom().wallWidthCm || 380) * 100;
      return Math.max(1.6, Math.min(92, baseWidth * state.artworkZoom));
    }

    function renderCanvas() {
      elements.wall.innerHTML = state.items.map(function (item) {
        var width = artworkWidthPercent(item);
        var ratio = Number(item.widthCm || 1) / Math.max(1, Number(item.heightCm || 1));
        return '<button type="button" class="lp-artwork' + (state.selectedId === item.uid ? " is-selected" : "") + '"' +
          ' data-lp-artwork="' + escapeHTML(item.uid) + '" data-frame="' + escapeHTML(item.frame || "none") + '"' +
          ' aria-label="' + escapeHTML(item.title + ", " + item.sizeLabel) + '"' +
          ' style="left:' + Number(item.x || 50).toFixed(3) + '%;top:' + Number(item.y || 32).toFixed(3) + '%;--lp-art-width:' + width.toFixed(3) + '%;--lp-art-ratio:' + ratio.toFixed(5) + ';">' +
          '<span class="lp-artwork__frame"><img src="' + escapeHTML(item.artworkImage) + '" alt="" draggable="false"></span>' +
        '</button>';
      }).join("");
      elements.empty.hidden = state.items.length > 0;
      renderInspector();
    }

    async function hydrateItemOptions(item) {
      var productMeta = state.productMap.get(item.handle) || {
        handle: item.handle,
        artworkWidth: item.artworkWidth,
        artworkHeight: item.artworkHeight
      };
      try {
        var productJson = await fetchProduct(item.handle);
        var options = availableVariants(productJson, productMeta);
        item.options = options;
        var current = options.find(function (option) { return Number(option.id) === Number(item.variantId); }) || options[0];
        if (current) {
          item.variantId = current.id;
          item.sizeLabel = current.label;
          item.widthCm = current.widthCm;
          item.heightCm = current.heightCm;
          item.price = current.price;
          item.compareAtPrice = current.compareAtPrice;
        }
      } catch (error) {
        item.options = item.options || [];
      }
      return item;
    }

    async function refreshRestoredItems() {
      if (!state.items.length) return;
      await Promise.all(state.items.map(hydrateItemOptions));
      renderCanvas();
      renderSummary();
      saveDraft(false);
    }

    function selectedItem() {
      return state.items.find(function (item) { return item.uid === state.selectedId; }) || null;
    }

    function renderInspector() {
      var item = selectedItem();
      elements.inspector.hidden = !item;
      if (!item) return;
      elements.selectedTitle.textContent = item.title;
      var optionMarkup = function (option) {
        return '<option value="' + option.id + '"' + (Number(option.id) === Number(item.variantId) ? " selected" : "") + '>' + escapeHTML(option.label + " - " + formatMoney(option.price)) + '</option>';
      };
      var groups = groupedOptions(item.options || []);
      elements.size.innerHTML = groups.more.length
        ? '<optgroup label="' + escapeHTML(labels.popularSizes || "Popular sizes") + '">' + groups.popular.map(optionMarkup).join("") + '</optgroup>' +
          '<optgroup label="' + escapeHTML(labels.moreSizes || "More sizes") + '">' + groups.more.map(optionMarkup).join("") + '</optgroup>'
        : groups.popular.map(optionMarkup).join("");
      elements.size.disabled = !(item.options && item.options.length);
      elements.frameInputs.forEach(function (input) { input.checked = input.value === (item.frame || "none"); });

      if (!(item.options && item.options.length)) {
        hydrateItemOptions(item).then(function () {
          if (state.selectedId === item.uid) {
            renderInspector();
            renderCanvas();
            renderSummary();
          }
        });
      }
    }

    function renderSummary() {
      var quantity = state.items.length;
      var total = state.items.reduce(function (sum, item) { return sum + Number(item.price || 0); }, 0);
      var compare = state.items.reduce(function (sum, item) {
        var value = Number(item.compareAtPrice || 0);
        return sum + (value > Number(item.price || 0) ? value : Number(item.price || 0));
      }, 0);
      if (elements.sizeGuideLink) {
        var item = selectedItem();
        var orientation = "";
        if (item) {
          if (Math.abs(Number(item.widthCm) - Number(item.heightCm)) < 0.01) orientation = "square";
          else orientation = Number(item.widthCm) > Number(item.heightCm) ? "landscape" : "portrait";
        }
        elements.sizeGuideLink.href = rootUrl + "pages/wall-art-size-guide" + (orientation ? "?orientation=" + orientation : "") + "#compare-sizes";
      }
      // The store's automatic multi-buy discount, so the planner total matches the cart.
      var percent = multibuyPercent(quantity);
      var payable = percent ? Math.round(total * (100 - percent) / 100) : total;
      var countText = quantity + " " + (quantity === 1 ? (labels.item || "item") : (labels.items || "items"));
      if (percent) countText += " · " + String(labels.multibuy || "multi-buy [percent]% off").replace("[percent]", percent);
      elements.itemCount.textContent = countText;
      elements.total.innerHTML = quantity
        ? '<span>' + escapeHTML(formatMoney(payable)) + '</span>' + (compare > payable ? ' <del>' + escapeHTML(formatMoney(compare)) + '</del>' : '')
        : escapeHTML(labels.emptyTotal || "Empty wall");
      elements.addWall.disabled = quantity === 0;
    }

    function setRoom(roomKey, persist) {
      if (!config.rooms || !config.rooms[roomKey]) roomKey = "sofa";
      state.room = roomKey;
      var room = activeRoom();
      elements.roomImage.src = room.image;
      elements.roomImage.alt = room.label || roomKey;
      elements.roomButtons.forEach(function (button) {
        button.classList.toggle("is-active", button.dataset.lpRoom === roomKey);
        button.setAttribute("aria-pressed", String(button.dataset.lpRoom === roomKey));
      });
      if (elements.roomHint) {
        elements.roomHint.hidden = roomKey !== "custom";
        elements.roomHint.classList.remove("is-compact");
        window.clearTimeout(roomHintTimer);
        if (roomKey === "custom") roomHintTimer = window.setTimeout(function () { elements.roomHint.classList.add("is-compact"); }, 7000);
      }
      renderCanvas();
      if (persist !== false) saveDraft(true);
    }

    function customRoom(image) {
      return { label: labels.uploadRoom || "Your room", image: image, wallWidthCm: 300, defaultY: 35 };
    }

    function restoreCustomRoom() {
      try {
        var image = window.localStorage.getItem(CUSTOM_ROOM_KEY);
        if (image && image.indexOf("data:image/") === 0) config.rooms.custom = customRoom(image);
      } catch (error) {
        // Storage can be blocked; the shopper can still upload for this visit.
      }
    }

    function chooseRoomPhoto() {
      if (!elements.roomFile) return;
      elements.roomFile.value = "";
      elements.roomFile.click();
    }

    // The photo is resized in the browser and kept on this device only; nothing is uploaded to Laboo.
    function useRoomPhoto(file) {
      if (!file || !/^image\//.test(file.type || "")) {
        elements.status.textContent = labels.uploadRoomError || "That photo could not be opened.";
        return;
      }
      var objectUrl = URL.createObjectURL(file);
      var image = new Image();
      image.onload = function () {
        var scale = Math.min(1, CUSTOM_ROOM_MAX_EDGE / Math.max(image.naturalWidth, image.naturalHeight));
        var canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(objectUrl);
        var dataUrl = canvas.toDataURL("image/jpeg", 0.82);
        config.rooms.custom = customRoom(dataUrl);
        try {
          window.localStorage.setItem(CUSTOM_ROOM_KEY, dataUrl);
        } catch (error) {
          // Too large for storage: the photo still works until the page is closed.
        }
        elements.status.textContent = "";
        setRoom("custom", true);
      };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        elements.status.textContent = labels.uploadRoomError || "That photo could not be opened.";
      };
      image.src = objectUrl;
    }

    function setArtworkZoom(value, persist, rerender) {
      state.artworkZoom = Math.max(.8, Math.min(2.2, Number(value || 1)));
      var zoomValue = Math.round(state.artworkZoom * 100);
      if (elements.zoom) {
        var zoomMin = Number(elements.zoom.min || 80);
        var zoomMax = Number(elements.zoom.max || 220);
        var zoomProgress = ((zoomValue - zoomMin) / (zoomMax - zoomMin)) * 100;
        elements.zoom.value = String(zoomValue);
        elements.zoom.style.setProperty("--lp-zoom-progress", zoomProgress + "%");
      }
      if (elements.zoomOutput) elements.zoomOutput.textContent = zoomValue + "%";
      if (rerender !== false) renderCanvas();
      if (persist !== false) saveDraft(false);
    }

    function saveDraft(showMessage) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
          room: state.room,
          artworkZoom: state.artworkZoom,
          items: state.items.map(function (item) {
            return {
              uid: item.uid,
              handle: item.handle,
              title: item.title,
              url: item.url,
              artworkImage: item.artworkImage,
              artworkWidth: item.artworkWidth,
              artworkHeight: item.artworkHeight,
              x: item.x,
              y: item.y,
              frame: item.frame,
              variantId: item.variantId,
              sizeLabel: item.sizeLabel,
              widthCm: item.widthCm,
              heightCm: item.heightCm,
              price: item.price,
              compareAtPrice: item.compareAtPrice
            };
          })
        }));
        if (showMessage) showSaveMessage();
      } catch (error) {
        // The planner remains usable when storage is unavailable.
      }
    }

    function restoreDraft() {
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
        if (saved && config.rooms && config.rooms[saved.room]) state.room = saved.room;
        if (saved && saved.artworkZoom) state.artworkZoom = Number(saved.artworkZoom);
        if (saved && Array.isArray(saved.items)) {
          state.items = saved.items.filter(function (item) {
            return item && item.handle && item.variantId && item.artworkImage;
          }).slice(0, MAX_ARTWORKS);
        }
      } catch (error) {
        state.items = [];
      }
    }

    function showSaveMessage() {
      if (!elements.saveStatus) return;
      window.clearTimeout(saveMessageTimer);
      elements.saveStatus.textContent = labels.saved || "Wall saved on this device";
      elements.saveStatus.classList.add("is-visible");
      saveMessageTimer = window.setTimeout(function () {
        elements.saveStatus.classList.remove("is-visible");
      }, 1600);
    }

    function removeSelected() {
      if (!state.selectedId) return;
      state.items = state.items.filter(function (item) { return item.uid !== state.selectedId; });
      state.selectedId = "";
      renderCanvas();
      renderSummary();
      saveDraft(true);
    }

    function updateSize(variantId) {
      var item = selectedItem();
      if (!item) return;
      var option = (item.options || []).find(function (entry) { return Number(entry.id) === Number(variantId); });
      if (!option) return;
      item.variantId = option.id;
      item.sizeLabel = option.label;
      item.widthCm = option.widthCm;
      item.heightCm = option.heightCm;
      item.price = option.price;
      item.compareAtPrice = option.compareAtPrice;
      renderCanvas();
      renderSummary();
      saveDraft(true);
    }

    function updateFrame(frame) {
      var item = selectedItem();
      if (!item) return;
      item.frame = frame;
      renderCanvas();
      saveDraft(true);
    }

    function renderCartDrawer(html) {
      if (!html) return;
      var section = new DOMParser().parseFromString(html, "text/html");
      var incomingForm = section.getElementById("AjaxCartForm");
      var incomingSubtotal = section.getElementById("AjaxCartSubtotal");
      var currentForm = document.getElementById("AjaxCartForm");
      var currentSubtotal = document.getElementById("AjaxCartSubtotal");
      if (!incomingForm || !incomingSubtotal || !currentForm || !currentSubtotal) return;
      currentForm.innerHTML = incomingForm.innerHTML;
      if (typeof currentForm.ajaxifyCartItems === "function") currentForm.ajaxifyCartItems();
      currentSubtotal.innerHTML = incomingSubtotal.innerHTML;
      document.querySelectorAll("[data-header-cart-count]").forEach(function (element) {
        var count = currentForm.querySelector("[data-cart-count]");
        if (count) element.textContent = count.textContent;
      });
      document.querySelectorAll("[data-header-cart-total]").forEach(function (element) {
        var total = currentForm.querySelector("[data-cart-total]");
        if (total) element.textContent = total.textContent;
      });
    }

    async function addWallToCart() {
      if (!state.items.length || elements.addWall.disabled) return;
      elements.addWall.disabled = true;
      elements.addWall.setAttribute("aria-busy", "true");
      var originalLabel = elements.addWall.textContent;
      elements.addWall.textContent = labels.adding || "Adding wall...";
      var items = state.items.map(function (item) {
        return {
          id: Number(item.variantId),
          quantity: 1,
          properties: { "_laboo_planner": "Laboo Planner" }
        };
      });

      try {
        var options = {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: items })
        };
        var result;
        if (typeof window.labooCartRequest === "function") {
          result = await window.labooCartRequest(config.cartAddUrl || rootUrl + "cart/add.js", options);
        } else {
          var response = await fetch(config.cartAddUrl || rootUrl + "cart/add.js", options);
          result = await response.json().catch(function () { return {}; });
          if (!result.status) result.status = response.status;
        }
        if (result && Number(result.status) >= 400) throw new Error(result.description || result.message || labels.error);

        if (window.KROWN && KROWN.settings && KROWN.settings.cart_action === "page") {
          window.location.href = config.cartUrl || rootUrl + "cart";
          return;
        }

        var sectionText = typeof window.labooCartSectionText === "function"
          ? await window.labooCartSectionText(result)
          : await fetch("?section_id=helper-cart", { credentials: "same-origin" }).then(function (response) { return response.text(); });
        renderCartDrawer(sectionText);
        var drawer = document.getElementById("site-cart-sidebar");
        if (drawer && typeof drawer.show === "function") drawer.show();
        elements.addWall.textContent = labels.added || "Added to cart";
        window.setTimeout(function () { elements.addWall.textContent = originalLabel; }, 1700);
      } catch (error) {
        elements.addWall.textContent = labels.error || "Please try again";
        window.setTimeout(function () { elements.addWall.textContent = originalLabel; }, 2200);
      } finally {
        elements.addWall.removeAttribute("aria-busy");
        elements.addWall.disabled = state.items.length === 0;
      }
    }

    function bindDrag(button, item, event) {
      if (event.button !== undefined && event.button !== 0) return;
      event.preventDefault();
      state.selectedId = item.uid;
      button.classList.add("is-selected");
      renderInspector();
      var pointerId = event.pointerId;
      if (button.setPointerCapture && pointerId !== undefined) button.setPointerCapture(pointerId);

      function move(moveEvent) {
        var rect = elements.wall.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        item.x = Math.max(2, Math.min(98, (moveEvent.clientX - rect.left) / rect.width * 100));
        item.y = Math.max(3, Math.min(62, (moveEvent.clientY - rect.top) / rect.height * 100));
        button.style.left = item.x.toFixed(3) + "%";
        button.style.top = item.y.toFixed(3) + "%";
      }

      function end() {
        button.removeEventListener("pointermove", move);
        button.removeEventListener("pointerup", end);
        button.removeEventListener("pointercancel", end);
        saveDraft(true);
      }

      button.addEventListener("pointermove", move);
      button.addEventListener("pointerup", end);
      button.addEventListener("pointercancel", end);
    }

    function bindEvents() {
      elements.products.addEventListener("click", function (event) {
        var wishlistButton = event.target.closest("[data-lp-wishlist]");
        if (wishlistButton) {
          event.preventDefault();
          var handle = wishlistButton.dataset.lpWishlist;
          var product = state.productMap.get(handle);
          if (window.LabooWishlist) window.LabooWishlist.toggle(handle, product ? product.title : "");
          return;
        }
        var addButton = event.target.closest("[data-lp-add-product]");
        if (addButton) addProduct(addButton.dataset.lpAddProduct);
      });

      root.querySelectorAll("[data-lp-tab]").forEach(function (tab) {
        tab.addEventListener("click", function () {
          state.tab = tab.dataset.lpTab;
          root.querySelectorAll("[data-lp-tab]").forEach(function (button) {
            var active = button === tab;
            button.classList.toggle("is-active", active);
            button.setAttribute("aria-selected", String(active));
          });
          if (state.tab === "wishlist") loadWishlistProducts();
          renderProducts();
        });
      });

      elements.search.addEventListener("input", function () {
        state.search = elements.search.value.trim().toLowerCase();
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () {
          performSearch();
        }, 180);
      });

      if (elements.categoryTrigger) elements.categoryTrigger.addEventListener("click", function () {
        setCategoryPanelOpen(true, false);
      });
      elements.categoryClose.forEach(function (button) {
        button.addEventListener("click", function () { setCategoryPanelOpen(false, true); });
      });
      elements.categoryOptions.forEach(function (button) {
        button.addEventListener("click", function () { applyCategory(button); });
      });
      elements.categoryGroups.forEach(function (group) {
        group.addEventListener("toggle", function () {
          if (!group.open) return;
          elements.categoryGroups.forEach(function (other) {
            if (other !== group) other.open = false;
          });
        });
      });

      elements.filters.forEach(function (select) {
        select.addEventListener("change", function () {
          var key = select.dataset.lpFilter;
          var option = select.options[select.selectedIndex];
          state.filters[key] = select.value;
          state.filterNames[key] = select.value && option ? option.dataset.filterName || "" : "";
          state.filterParams[key] = select.value && option ? option.dataset.filterParam || "" : "";
          if (state.searchResults !== null || state.tab === "wishlist") {
            renderProducts();
            return;
          }
          state.products = [];
          state.page = 0;
          state.pages = 1;
          state.totalProducts = 0;
          elements.products.innerHTML = "";
          loadPage(1, true);
        });
      });

      elements.loadMore.addEventListener("click", loadMoreProducts);
      elements.roomButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var key = button.dataset.lpRoom;
          if (key === "custom" && (!config.rooms.custom || state.room === "custom")) {
            chooseRoomPhoto();
            return;
          }
          setRoom(key, true);
        });
      });
      if (elements.roomFile) elements.roomFile.addEventListener("change", function () { useRoomPhoto(elements.roomFile.files && elements.roomFile.files[0]); });
      if (elements.roomChange) elements.roomChange.addEventListener("click", chooseRoomPhoto);
      if (elements.zoom) elements.zoom.addEventListener("input", function () { setArtworkZoom(Number(elements.zoom.value) / 100, true); });
      elements.size.addEventListener("change", function () { updateSize(elements.size.value); });
      elements.frameInputs.forEach(function (input) { input.addEventListener("change", function () { if (input.checked) updateFrame(input.value); }); });
      elements.remove.addEventListener("click", removeSelected);
      elements.deselect.addEventListener("click", function () { state.selectedId = ""; renderCanvas(); });
      elements.addWall.addEventListener("click", addWallToCart);
      elements.scrollCatalogue.addEventListener("click", openCatalogue);
      elements.catalogueClose.addEventListener("click", function () { closeCatalogue(true); });
      elements.catalogueBackdrop.addEventListener("click", function () { closeCatalogue(false); });
      elements.rotateDismiss.addEventListener("click", hideRotatePrompt);

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        if (elements.categoryPanel && !elements.categoryPanel.hidden) {
          setCategoryPanelOpen(false, true);
          return;
        }
        if (root.classList.contains("is-catalogue-open")) closeCatalogue(true);
      });

      elements.wall.addEventListener("pointerdown", function (event) {
        var button = event.target.closest("[data-lp-artwork]");
        if (!button) {
          state.selectedId = "";
          renderCanvas();
          return;
        }
        var item = state.items.find(function (entry) { return entry.uid === button.dataset.lpArtwork; });
        if (item) bindDrag(button, item, event);
      });

      elements.wall.addEventListener("keydown", function (event) {
        var button = event.target.closest("[data-lp-artwork]");
        if (!button) return;
        var item = state.items.find(function (entry) { return entry.uid === button.dataset.lpArtwork; });
        if (!item) return;
        var step = event.shiftKey ? 2 : .5;
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Delete", "Backspace"].indexOf(event.key) === -1) return;
        event.preventDefault();
        state.selectedId = item.uid;
        if (event.key === "Delete" || event.key === "Backspace") {
          removeSelected();
          return;
        }
        if (event.key === "ArrowLeft") item.x -= step;
        if (event.key === "ArrowRight") item.x += step;
        if (event.key === "ArrowUp") item.y -= step;
        if (event.key === "ArrowDown") item.y += step;
        item.x = Math.max(2, Math.min(98, item.x));
        item.y = Math.max(3, Math.min(62, item.y));
        renderCanvas();
        saveDraft(false);
      });

      document.addEventListener("laboo:wishlist:change", function () {
        renderWishlistCount();
        if (state.tab === "wishlist") loadWishlistProducts();
        else renderProducts();
      });
    }
  }

  function initialize() {
    document.querySelectorAll("[data-laboo-planner]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
})();
